/* NUOLS: スマホメニュー(第2階層)の開閉アニメーション
   テーマ標準の開閉アニメーションはCSSで止め、このJSだけで高さを動かす
   (2つが同時に動くとカクつくため)。文字が流れる動きはCSS。
   高さと一緒に上下の余白(padding)も動かし、最後に余白分がカクンと跳ぶのを防ぐ。 */
(function () {
  var SELECTOR = '.menu-drawer accordion-custom details';
  var OPEN_DURATION = 380;
  var CLOSE_DURATION = 380;
  var ITEM_FADE = 200;
  var ITEM_STEP = 40;
  var EASE_OPEN = 'cubic-bezier(0.33, 1, 0.68, 1)';
  var EASE_CLOSE = 'cubic-bezier(0.32, 0, 0.24, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasCSSAnimation = typeof window.CSSAnimation !== 'undefined';

  function getContent(details) {
    for (var i = 0; i < details.children.length; i++) {
      if (details.children[i].classList.contains('details-content')) return details.children[i];
    }
    return null;
  }

  function cancelScriptAnimations(el) {
    el.getAnimations().forEach(function (a) {
      if (!hasCSSAnimation || !(a instanceof window.CSSAnimation)) a.cancel();
    });
  }

  /* 開いた状態の実際の高さと上下余白を測る */
  function measure(content) {
    var cs = getComputedStyle(content);
    return {
      full: { height: cs.height, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom },
      empty: { height: '0px', paddingTop: '0px', paddingBottom: '0px' }
    };
  }

  function open(details, content) {
    details.dataset.nuolsAnimating = 'open';
    details.open = true;

    var m = measure(content);
    content.style.overflow = 'hidden';

    var anim = content.animate([m.empty, m.full], {
      duration: OPEN_DURATION,
      easing: EASE_OPEN
    });
    anim.onfinish = anim.oncancel = function () {
      content.style.overflow = '';
      delete details.dataset.nuolsAnimating;
    };
  }

  function close(details, content) {
    details.dataset.nuolsAnimating = 'close';

    var items = Array.prototype.slice.call(content.children).reverse();
    items.forEach(function (li, i) {
      li.animate(
        [
          { opacity: 1, transform: 'translate3d(0, 0, 0)' },
          { opacity: 0, transform: 'translate3d(0, -6px, 0)' }
        ],
        { duration: ITEM_FADE, delay: i * ITEM_STEP, easing: 'ease-out', fill: 'forwards' }
      );
    });

    var m = measure(content);
    content.style.overflow = 'hidden';

    var anim = content.animate([m.full, m.empty], {
      duration: CLOSE_DURATION,
      easing: EASE_CLOSE,
      fill: 'forwards'
    });
    anim.onfinish = function () {
      details.open = false;
      /* 閉じた状態が描画されてから後片付け(一瞬元の高さに戻るのを防ぐ) */
      requestAnimationFrame(function () {
        content.style.overflow = '';
        cancelScriptAnimations(content);
        Array.prototype.forEach.call(content.children, cancelScriptAnimations);
        delete details.dataset.nuolsAnimating;
      });
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest && event.target.closest('summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details || !details.matches(SELECTOR)) return;
      if (reduceMotion.matches || typeof Element.prototype.animate !== 'function') return;

      var content = getContent(details);
      if (!content) return;

      event.preventDefault();
      if (details.dataset.nuolsAnimating) return;

      if (details.open) {
        close(details, content);
      } else {
        open(details, content);
      }
    },
    true
  );
})();
